import React from 'react'
import { useTranslation } from 'react-i18next';

// ! MODEL
import { IFilterParam } from '../../models/IFilterParam';
import { IdObject } from '../../models/IdObject';

// ! RECOIL
import { useRecoilState } from 'recoil';
import selectedCheckboxsAtom from '../../recoils/useSelectedCheckboxsReverseSearch/selectedCheckboxsAtom';
import searchRequestAtom from '../../recoils/useSearchRequest/searchRequestAtom';
import { ISearchQueryRequest } from '../../models/ISearchQueryRequest';

// ! SUPPORT FUNCTION
import { uniqueFilterRequest, removeDuplicates, getAndUpdateRequestForFilter } from '../../ultils';

import './BoxCellCustom.scss';

interface IProps {
    data: any;
}

export const BoxCellVertical: React.FC<IProps> = (props: any) => {
    const { data } = props;
    const { t } = useTranslation();

    const [listCheckbox, setListCheckBox] = useRecoilState(selectedCheckboxsAtom);
    const [searchQuery, setSearchQuery] = useRecoilState(searchRequestAtom);

    const handleCheckBoxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        let parametricFilters: IFilterParam[] = searchQuery.parametricFilters
            ? [...searchQuery.parametricFilters]
            : [];
        let updateRequest: ISearchQueryRequest = {
            ...searchQuery
        };
        //these below use another method to update request
        switch (data.fieldMapping) {
            //Unique request
            case 'partStatus':
                updateRequest = getAndUpdateRequestForFilter(searchQuery, searchQuery.productStatusFilter, data.sourceData.partStatusId, e.target.checked)
                break;
            //Unique request
            case 'packageTypeCellRenderer':
                let packageFilter: IdObject[] = searchQuery.packagingFilter
                    ? [...searchQuery.packagingFilter]
                    : [];
                data.secondColumn?.forEach((iProduct: any) => {
                    let newFilter: IdObject = {
                        id: iProduct.packageType.id.toString()
                    };
                    packageFilter = [...packageFilter, newFilter];
                });
                packageFilter = removeDuplicates(packageFilter, 'id')
                updateRequest = uniqueFilterRequest(
                    updateRequest,
                    packageFilter,
                    'packagingFilter',
                    e.target.checked
                );
                break;
            case 'seriesName':
                let seriesFilter: IdObject[] = searchQuery.seriesFilter
                    ? [...searchQuery.seriesFilter]
                    : [];
                let newFilter: IdObject = { id: data.sourceData.seriesId.toString() };
                seriesFilter = [...seriesFilter, newFilter];
                updateRequest = uniqueFilterRequest(
                    updateRequest,
                    seriesFilter,
                    'seriesFilter',
                    e.target.checked
                );
                break;
            default:
                const getParam = data.sourceData.parameters.find((iParam: any) => {
                    return iParam.parameterId === data.parameterId;
                });
                if (e.target.checked) {
                    const newParamFilter: IFilterParam = {
                        filterValues: [
                            {
                                valueId: getParam.valueId
                            }
                        ],
                        parameterId: getParam.parameterId,
                        parameterType: getParam.parameterType
                    };
                    updateRequest = {
                        ...searchQuery,
                        parametricFilters: [...parametricFilters, newParamFilter]
                    };
                } else {
                    parametricFilters = parametricFilters.filter(
                        (eParam: IFilterParam) => {
                            return eParam.parameterId !== getParam.parameterId;
                        }
                    );
                    if (parametricFilters.length > 0) {
                        updateRequest = {
                            ...searchQuery,
                            parametricFilters: [...parametricFilters]
                        };
                    } else {
                        updateRequest = {
                            ...searchQuery,
                            parametricFilters: undefined
                        };
                        delete updateRequest.parametricFilters;
                    }
                }
        }

        if (e.target.checked) {
            let newList = [...listCheckbox, data.fieldMapping];
            setListCheckBox([...newList]);
        } else {
            let newList = listCheckbox.filter((iCheckbox: string) => {
                return iCheckbox !== data.fieldMapping;
            });
            setListCheckBox([...newList]);
        }

        setSearchQuery(updateRequest);
    };

    // ! Replace checkbox by text
    if (data.fieldMapping === "manufacturerProductNumber") {
        return (
            <div>
                <h4 id='first-row-title' className='text-center'>{t('xref-find-parts-matching-selected-parameters')}</h4>
            </div>
        )
    }

    // ! Remove Checkbox 
    if (data.fieldMapping === "unitPrice" || data.fieldMapping === "digikeyPartNumber" || data.fieldMapping === "quantityAvailable") {
        return null
    }

    return (
        <div>
            <input type="checkbox" col-id={data.fieldMapping}
                className="dk-checkbox dk-checkbox-matching-part"
                id="include-matching-part"
                data-testid="include-matching-part"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    handleCheckBoxChange(e)}
            />
        </div>
    )
}
